import { render, staticRenderFns } from "./DetailImg.vue?vue&type=template&id=44d448a4&scoped=true"
import script from "./DetailImg.vue?vue&type=script&lang=js"
export * from "./DetailImg.vue?vue&type=script&lang=js"
import style0 from "./DetailImg.vue?vue&type=style&index=0&id=44d448a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d448a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d448a4')) {
      api.createRecord('44d448a4', component.options)
    } else {
      api.reload('44d448a4', component.options)
    }
    module.hot.accept("./DetailImg.vue?vue&type=template&id=44d448a4&scoped=true", function () {
      api.rerender('44d448a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/product/components/DetailImg.vue"
export default component.exports